
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetomumbaiinternationalairport() {



  const cardData =
  {
    keyword: ' Pune to Mumbai International Airport Cab',
    heading: 'Vaishnavi Travels: Pune to Mumbai International Airport Cab',
    headingDescription: 'Vaishnavi Travels provides reliable and affordable Pune to Mumbai International Airport Cab service, ensuring timely and comfortable travel for individuals, families, and corporate clients. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage capacity to handle all your travel needs with ease. With professional chauffeurs, punctual pickups, and flexible booking options, we guarantee a hassle-free journey on the Pune–Mumbai airport route. Whether it’s an early morning flight, late-night departure, or urgent business travel, Vaishnavi Travels ensures safe, convenient, and stress-free cab services from Pune to Mumbai International Airport.',

    top: 'Top Places to Visit in Mumbai with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorated the visit of King George V and Queen Mary. Today, it is a bustling hub for tourists, ferry rides, and photography. The evening view with the Taj Mahal Palace Hotel in the backdrop is spectacular. Street vendors, performers, and boat trips add vibrancy. Gateway of India is Mumbai’s proud symbol of heritage and grandeur."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km promenade curving along the Arabian Sea. At night, its streetlights resemble a glittering necklace, making it Mumbai’s most romantic spot. Locals enjoy jogging, relaxing, and watching sunsets here. During monsoon, huge waves create a dramatic atmosphere. The stretch is also close to Girgaon Chowpatty and cultural hubs. Marine Drive is Mumbai’s soul-soothing escape from urban hustle."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site, are located on Elephanta Island, 11 km from Mumbai. These 5th–8th century rock-cut caves are dedicated to Lord Shiva, with the grand Trimurti sculpture as the highlight. Ferries from the Gateway of India take visitors across scenic waters. The caves reflect India’s artistic brilliance and spirituality. Nature, history, and devotion blend beautifully here. Elephanta Caves are Mumbai’s timeless treasure of heritage."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887, it features Gothic Revival architecture with domes, spires, stained glass, and carvings. At night, the illuminated façade creates a majestic sight. It is not just a transport hub but also a heritage monument. Tourists admire its blend of Victorian and Indian styles. CSMT is Mumbai’s living symbol of colonial architecture and connectivity."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside attraction, famous for its golden sands and lively atmosphere. Families, joggers, and tourists gather here for sunsets and breezy evenings. Street vendors serve pav bhaji, bhel puri, and ice gola, making it a foodie’s paradise. Bollywood celebrities often visit, as many live nearby. Festivals and cultural programs add vibrancy to the beach. Juhu Beach is Mumbai’s seaside hotspot for leisure and fun."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts lakhs of devotees, including Bollywood stars and business leaders. The black stone idol with its trunk turned right is considered highly auspicious. Tuesdays are especially crowded with special darshan rituals. The temple’s divine aura provides peace amidst city chaos. Siddhivinayak Temple is Mumbai’s beacon of faith and devotion."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in 1431, is located on a small islet in the Arabian Sea. The white marble mosque houses the tomb of Pir Haji Ali Shah Bukhari. A narrow causeway connects it to the mainland, creating a scenic walk during low tide. Thousands of devotees visit irrespective of religion, seeking blessings. The sunset view here is mesmerizing. Haji Ali is Mumbai’s iconic symbol of unity, faith, and spirituality."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most vibrant shopping street, filled with stalls selling clothes, jewelry, antiques, and handicrafts. Tourists enjoy bargaining and exploring the colorful market. It is also home to famous cafés like Leopold Café and Café Mondegar. Heritage buildings along the stretch add charm to the experience. The bustling energy makes it a must-visit for shopaholics. Colaba Causeway is Mumbai’s ultimate hub for street shopping and culture."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty, also known as Chowpatty Beach, is one of Mumbai’s cultural landmarks. It is famous for Ganesh Visarjan celebrations where thousands gather for immersion processions. Families enjoy evenings here with local street food like pav bhaji and kulfi. The Arabian Sea backdrop adds to its beauty. Cultural fairs and festivals make it lively throughout the year. Girgaon Chowpatty is Mumbai’s seaside celebration of traditions and community."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, spread over 100 sq km, is one of the world’s largest parks within a metropolitan city. It is home to leopards, deer, monkeys, and hundreds of bird species. The park also houses the ancient Kanheri Caves, a group of Buddhist rock-cut structures. Visitors enjoy safaris, boating, and trekking trails. Its greenery provides a refreshing break from the city’s rush. Sanjay Gandhi National Park is Mumbai’s natural oasis of wildlife and heritage."
  }
],


     "services": [
    {
      "name": "Pune to Mumbai Airport Taxi",
      "description": "Reliable taxi services from Pune to Mumbai Airport (CSMIA) ensuring timely pickups and drop-offs. Our fleet includes comfortable sedans and SUVs with professional drivers who prioritize safety and punctuality for your airport transfers."
    },
    {
      "name": "Metro Airport Pick up Pune",
      "description": "Convenient metro airport pick-up service in Pune, designed to provide seamless transfers between metro stations and airport terminals. Ideal for travelers looking for quick, hassle-free connectivity with trained drivers."
    },
    {
      "name": "Airport Transfer Cab Pune Mumbai",
      "description": "Efficient and affordable cab service for transfers between Pune and Mumbai airports. Whether it’s a business trip or personal travel, our AC and non-AC cabs ensure a comfortable journey with real-time tracking and flight monitoring."
    },
    {
      "name": "AC Cab to Mumbai International Airport",
      "description": "Travel in cool comfort with our air-conditioned cabs from Pune to Mumbai International Airport. Equipped with spacious interiors, safety features, and experienced chauffeurs, perfect for long-distance airport rides."
    },
    {
      "name": "Corporate Airport Cab Service",
      "description": "Specialized airport transfer service tailored for corporate clients requiring timely, professional, and discreet travel solutions. Our fleet includes executive vehicles with amenities like Wi-Fi and bottled water."
    },
    {
      "name": "One Way Airport Taxi Pune",
      "description": "Book one-way taxi rides from Pune to Mumbai Airport or vice versa, perfect for solo travelers or small groups needing budget-friendly, reliable transport without round-trip commitments."
    },
    {
      "name": "Airport Drop Cab Booking Pune",
      "description": "Easy and quick online booking for airport drop cabs in Pune with confirmed pickup times, well-maintained vehicles, and courteous drivers ensuring you reach your terminal stress-free."
    },
    {
      "name": "Budget Airport Cab Pune Mumbai",
      "description": "Affordable airport taxi options for budget-conscious travelers without compromising on service quality. Our budget cabs are fuel-efficient and well-serviced, suitable for economical transfers."
    },
    {
      "name": "SUV Airport Transfer Cab",
      "description": "Spacious SUV cabs for group or family transfers to Mumbai airport from Pune, offering enhanced luggage capacity, comfortable seating, and premium interiors to make your journey relaxing."
    },
    {
      "name": "Online Airport Booking Taxi",
      "description": "Convenient online platform to book your airport taxi from Pune to Mumbai with instant confirmation, secure payments, and transparent fare estimates, available 24/7."
    },
    {
      "name": "Pune to CSMIA Cab Fare",
      "description": "Get accurate fare estimates for taxi rides from Pune to Chhatrapati Shivaji Maharaj International Airport (CSMIA), helping you plan your budget with no hidden charges."
    },
    {
      "name": "VIP Airport Taxi Pune",
      "description": "Premium VIP airport taxi service with luxury vehicles, professional chauffeurs, and special amenities like refreshments, personalized pickups, and flexible scheduling for executive travelers."
    },
    {
      "name": "Airport Shuttle Cab Pune",
      "description": "Shared airport shuttle cab services between Pune and Mumbai Airport, ideal for solo travelers and small groups seeking economical, eco-friendly transfer options with scheduled pickups."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Taxi", "Metro Airport Pick up Pune"],
    ["Airport Transfer Cab Pune Mumbai", "AC Cab to Mumbai International Airport"],
    ["Corporate Airport Cab Service", "One Way Airport Taxi Pune"],
    ["Airport Drop Cab Booking Pune", "Budget Airport Cab Pune Mumbai"],
    ["SUV Airport Transfer Cab", "Online Airport Booking Taxi"],
    ["Pune to CSMIA Cab Fare", "VIP Airport Taxi Pune"],
    ["Airport Shuttle Cab Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai International Airport Cab",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and timely cab services from Pune to Mumbai International Airport (T2), ensuring a stress-free airport transfer."
  },
  {
    "WhyChooseheading": "On-Time Pickup & Drop Guaranteed",
    "WhyChoosedescription": "We understand the importance of punctuality for airport travel — our drivers ensure you reach the airport well in time for your flight."
  },
  {
    "WhyChooseheading": "Multiple Cab Options to Suit Your Budget",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, or Urbania based on your group size, comfort, and luggage needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are regularly cleaned and maintained to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Experienced Airport-Trained Drivers",
    "WhyChoosedescription": "Our chauffeurs are familiar with Mumbai airport routes, terminals, and traffic conditions to ensure a smooth drop-off."
  },
  {
    "WhyChooseheading": "24x7 Airport Transfers – Day & Night",
    "WhyChoosedescription": "Whether it's an early morning flight or a late-night arrival, our cab services are available round-the-clock."
  },
  {
    "WhyChooseheading": "Fixed and Transparent Pricing",
    "WhyChoosedescription": "Enjoy all-inclusive fares with no hidden charges — fuel, tolls, driver allowance, and parking included."
  },
  {
    "WhyChooseheading": "Doorstep Pickup and Drop",
    "WhyChoosedescription": "We offer hassle-free pickup from your home, office, or hotel in Pune and drop you directly at the departure terminal."
  }
]












  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide cab services from Pune to Mumbai International Airport?',
      answer: 'Yes, Vaishnavi Travels offers reliable and comfortable cab services from Pune to Mumbai International Airport (Chhatrapati Shivaji Maharaj International Airport) for individuals, families, and business travelers.',
    },
    {
      question: 'What types of cabs are available for Pune to Mumbai Airport transfers?',
      answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Travellers to suit your budget and group size, with options for both one-way and round trips.',
    },
    {
      question: 'Are the drivers punctual and experienced for airport transfers?',
      answer: 'Absolutely! Our drivers are punctual, professional, and well-versed with the Pune–Mumbai route, ensuring timely drop-offs at the airport with buffer time for traffic.',
    },
    {
      question: 'What is the fare for a cab from Pune to Mumbai International Airport?',
      answer: 'Fares typically start from ₹3,500 for a sedan like Swift Dzire. Prices vary based on vehicle type, time of day (day/night), and any waiting time or return requirements.',
    },
    {
      question: 'Can I book a cab for odd hours or early morning flights from Pune to Mumbai Airport?',
      answer: 'Yes, we provide 24/7 cab services for airport transfers. Early morning or late-night pickups can be scheduled in advance for your convenience.',
    },
    {
      question: 'How early should I book a cab to Mumbai International Airport from Pune?',
      answer: 'It is advisable to book at least 24 hours in advance, and plan your departure 4.5 to 5.5 hours before your flight time, depending on traffic and terminal location.',
    },
    {
      question: 'Is doorstep pickup available for Pune to Mumbai Airport cab service?',
      answer: 'Yes, we offer hassle-free doorstep pickup from anywhere in Pune and nearby areas with timely drop-off at your desired airport terminal.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Abhay Patankar",
    position: "Frequent Flyer",
    feedback:
      "I always book my Pune to Mumbai airport transfers with Vaishnavi Travels. The service is dependable, drivers are always on time, and the cabs are clean and comfortable.",
    rating: 5,
  },
  {
    name: "Ms. Tanvi Desai",
    position: "Working Professional",
    feedback:
      "Vaishnavi Travels helped me catch my early morning international flight without any stress. The driver arrived on time and drove smoothly. Excellent airport cab service!",
    rating: 5,
    style: "style-2",
  }
];









































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai International Airport Cab",
  "description": "Reliable Pune to Mumbai Airport taxi service offering AC and non-AC cabs, corporate transfers, one-way and round-trip bookings with professional drivers.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "areaServed": "Pune, Mumbai",
    "url": "https://vaishnavitravel.com/pune-to-mumbai-international-airport-cab"
  },
  "serviceType": "Airport Transfer Taxi",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-mumbai-international-airport-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mumbai International Airport Cab | Airport Taxi Service</title>
  <meta
    name="description"
    content="Reliable Pune to Mumbai Airport taxi service offering AC and non-AC cabs, corporate transfers, one-way and round-trip bookings with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Taxi, Metro Airport Pick up Pune, Airport Transfer Cab Pune Mumbai, AC Cab to Mumbai International Airport, Corporate Airport Cab Service, One Way Airport Taxi Pune, Airport Drop Cab Booking Pune, Budget Airport Cab Pune Mumbai, SUV Airport Transfer Cab, Online Airport Booking Taxi, Pune to CSMIA Cab Fare, VIP Airport Taxi Pune, Airport Shuttle Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiinternationalairport;